export default __webpack_public_path__ + "static/media/KOD0132-min.8ac4cc94.webp";